import { render, staticRenderFns } from "./EstimatesOldSpecsIcon.vue?vue&type=template&id=c02ed1f6&"
import script from "./EstimatesOldSpecsIcon.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldSpecsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports